import { SVGProps } from '@components/Icon/types';

export const Gift = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M3.625 3.1875C3.625 1.97938 4.60438 1 5.8125 1C7.02062 1 8 1.97938 8 3.1875C8 1.97938 8.97938 1 10.1875 1C11.3956 1 12.375 1.97938 12.375 3.1875L12.375 3.19237C12.375 3.2535 12.3751 3.42871 12.3419 3.625H14.125C14.6082 3.625 15 4.01675 15 4.5V6.25C15 6.73325 14.6082 7.125 14.125 7.125V13.6875C14.125 14.4124 13.5374 15 12.8125 15H3.1875C2.46263 15 1.875 14.4124 1.875 13.6875L1.875 7.125C1.39175 7.125 1 6.73325 1 6.25V4.5C1 4.01675 1.39175 3.625 1.875 3.625H3.6581C3.62489 3.42871 3.62497 3.2535 3.625 3.19237C3.625 3.19066 3.625 3.18903 3.625 3.1875ZM4.55949 3.625H7.125V3.1875C7.125 2.46263 6.53737 1.875 5.8125 1.875C5.08763 1.875 4.5 2.46263 4.5 3.1875C4.5 3.26166 4.5017 3.42682 4.53927 3.56457C4.54595 3.58908 4.55288 3.60913 4.55949 3.625ZM8.875 3.625H11.4405C11.4471 3.60913 11.454 3.58908 11.4607 3.56457C11.4983 3.42682 11.5 3.26166 11.5 3.1875C11.5 2.46263 10.9124 1.875 10.1875 1.875C9.46263 1.875 8.875 2.46263 8.875 3.1875V3.625ZM1.875 4.5V6.25H7.125V4.5H1.875ZM8.875 4.5V6.25H14.125V4.5H8.875ZM13.25 7.125H8.875V14.125H12.8125C13.0541 14.125 13.25 13.9291 13.25 13.6875V7.125ZM7.125 14.125V7.125H2.75V13.6875C2.75 13.9291 2.94588 14.125 3.1875 14.125H7.125Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'gift';
